/* i18n: strings come from window.jabT (snippets/jab-i18n.liquid) */
var jT = window.jabTr || (window.jabTr = function (k, d, n) { var s = (window.jabT && window.jabT[k]) || d; return n != null ? s.replace('[n]', n) : s; });
/* ==========================================================================
   Jabree — Product page engine (jab-pdp.js)
   Variant selection, color-aware gallery, low-stock, Denim+Belt bundle,
   one-tap add (opens the Jabree side cart), sticky mobile ATC, size guide.
   Vanilla JS, no deps. Adds via window.fetch('/cart/add.js') so the existing
   jab-cart drawer interceptor catches it and opens.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__jabPdpLoaded) return;   // script is included by 2 sections; run once
  window.__jabPdpLoaded = 1;

  /* Symbol + placement come from window.jabMoneyParts (set in layout/theme.liquid
     from `{{ 0 | money }}`), so a EUR shopper sees € here and not a hardcoded $.
     Read lazily so load order can never matter. */
  function moneyParts() { return window.jabMoneyParts || { pre: '$', post: '' }; }
  function money(cents) {
    cents = Math.round(cents || 0);
    var d = (cents / 100);
    var p = moneyParts();
    return p.pre + (cents % 100 === 0 ? d.toFixed(0) : d.toFixed(2)) + p.post;
  }

  function initRoot(root) {
    if (root.__jpdp) return;
    root.__jpdp = 1;

    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    var variants = [];
    try { variants = JSON.parse($('[data-pdp-variants]').textContent); } catch (e) { variants = []; }
    if (!variants.length) return;

    var colorPos = root.hasAttribute('data-color-pos') ? parseInt(root.getAttribute('data-color-pos'), 10) - 1 : -1;
    var sizePos  = root.hasAttribute('data-size-pos')  ? parseInt(root.getAttribute('data-size-pos'), 10)  - 1 : -1;
    var lowStock = parseInt(root.getAttribute('data-low-stock'), 10) || 6;
    var preNote = root.getAttribute('data-preorder-note') || 'Ships to you August 28th';
    var forcePre = root.getAttribute('data-force-preorder') === '1';

    var state = { color: null, size: null, waist: null, length: null };
    var prunedLength = false;   // set by pruneSelection when a colour switch drops the length

    // default colour = first available variant's colour
    var firstAvail = variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (colorPos > -1) state.color = firstAvail.options[colorPos];

    // pre-select colour from ?variant= (e.g. arriving from a collection colourway card)
    if (colorPos > -1) {
      try {
        var _vp = new URLSearchParams(window.location.search).get('variant');
        if (_vp) {
          var _pv = variants.filter(function (v) { return String(v.id) === String(_vp); })[0];
          if (_pv) state.color = _pv.options[colorPos];
        }
      } catch (e) {}
    }

    /* ---------- helpers ---------- */
    function findVariant() {
      return variants.filter(function (v) {
        if (colorPos > -1 && v.options[colorPos] !== state.color) return false;
        if (sizePos  > -1 && state.size != null && v.options[sizePos] !== state.size) return false;
        return true;
      })[0];
    }
    function variantFor(color, size) {
      return variants.filter(function (v) {
        if (colorPos > -1 && v.options[colorPos] !== color) return false;
        if (sizePos  > -1 && v.options[sizePos]  !== size)  return false;
        return true;
      })[0];
    }
    // A variant is a pre-order when it is set to keep selling past zero and has none on hand.
    function isPre(v) { return !!v && (forcePre || (v.policy === 'continue' && (v.qty || 0) <= 0)); }
    // true when every sellable variant behind this button is a pre-order
    function allPre(list) {
      var sellable = list.filter(function (v) { return v.available; });
      return sellable.length > 0 && sellable.every(isPre);
    }
    function preForSize(size) {
      return allPre(variants.filter(function (v) {
        return (colorPos < 0 || v.options[colorPos] === state.color) &&
               (sizePos  < 0 || v.options[sizePos]  === size);
      }));
    }
    function preForPart(key, val) {
      return allPre(variants.filter(function (v) {
        if (colorPos > -1 && v.options[colorPos] !== state.color) return false;
        var ps = parseSize(v.options[sizePos]);
        if (ps[key] !== val) return false;
        var other = key === 'waist' ? 'length' : 'waist';
        var sel = key === 'waist' ? state.length : state.waist;
        if (sel != null && ps[other] !== sel) return false;
        return true;
      }));
    }

    function sizeAvailableForColor(size) {
      return variants.some(function (v) {
        return (colorPos < 0 || v.options[colorPos] === state.color) &&
               (sizePos  < 0 || v.options[sizePos]  === size) && v.available;
      });
    }

    /* ---------- gallery (swipe carousel) ---------- */
    var track = $('[data-track]');
    var slides = $$('[data-slide]');
    var thumbs = $$('[data-thumb]');
    // no-hide mode: keep every image visible, just jump to the selected colour's image
    var galleryNoHide = root.getAttribute('data-gallery-nohide') === '1';

    /* position dots under the photo: black = current photo, grey = the rest */
    var dots = [];
    if (track && slides.length > 1) {
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'jpdp__dots';
      dotsWrap.setAttribute('aria-hidden', 'true');
      slides.forEach(function (s, idx) {
        var d = document.createElement('span');
        d.className = 'jpdp__dot' + (idx === 0 ? ' is-on' : '');
        dotsWrap.appendChild(d);
        dots.push(d);
      });
      track.parentNode.insertBefore(dotsWrap, track.nextSibling);
    }
    function syncDots() {
      slides.forEach(function (s, idx) { if (dots[idx]) dots[idx].hidden = !!s.hidden; });
    }
    var thumbsWrap = $('[data-thumbs]');
    var activeIdx = -1;
    /* keep the selected preview thumbnail centred in the strip (scrolls the strip only, never the page) */
    function centerThumb(i, instant) {
      var t = thumbs[i];
      if (!thumbsWrap || !t || t.hidden || thumbsWrap.scrollWidth <= thumbsWrap.clientWidth) return;
      var wr = thumbsWrap.getBoundingClientRect(), tr = t.getBoundingClientRect();
      var delta = (tr.left - wr.left) - (wr.width - tr.width) / 2;
      if (Math.abs(delta) < 2) return;
      thumbsWrap.scrollBy({ left: delta, behavior: instant ? 'auto' : 'smooth' });
    }
    function setActiveThumb(i, instant) {
      thumbs.forEach(function (t, idx) { t.setAttribute('aria-current', idx === i ? 'true' : 'false'); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-on', idx === i); });
      if (i !== activeIdx) { activeIdx = i; centerThumb(i, instant); }
    }
    // Smooth-scroll the track to a slide, then verify it landed. Safari can cancel a programmatic
    // smooth scroll on a snap container and snap back to photo 1 (arrows looked dead on Mac Safari),
    // so if the track isn't there shortly after, jump instantly.
    function scrollToSlide(sl) {
      if (!track || !sl) return;
      var left = sl.offsetLeft - track.offsetLeft;
      track.scrollTo({ left: left, behavior: 'smooth' });
      setTimeout(function () {
        if (Math.abs(track.scrollLeft - left) > 4) { track.scrollLeft = left; setActiveThumb(slides.indexOf(sl)); }
      }, 600);
    }
    function goTo(i) {
      if (!slides[i]) return;
      if (track) scrollToSlide(slides[i]);
      else slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      setActiveThumb(i);
    }
    function filterGallery(initial) {
      var firstVisible = -1, exactIdx = -1;
      slides.forEach(function (s, idx) {
        var c = s.getAttribute('data-color');
        var match = !c || colorPos < 0 || c === state.color;
        // hide non-matching unless we're in no-hide mode
        s.hidden = galleryNoHide ? false : !match;
        if (thumbs[idx]) thumbs[idx].hidden = galleryNoHide ? false : !match;
        if (c && c === state.color && exactIdx < 0) exactIdx = idx;   // image tagged for THIS colour
        if (!s.hidden && firstVisible < 0) firstVisible = idx;
      });
      // (hide mode) nothing matched this colour → show everything
      if (!galleryNoHide) {
        var anyVisible = slides.some(function (s) { return !s.hidden; });
        if (!anyVisible) {
          slides.forEach(function (s) { s.hidden = false; });
          thumbs.forEach(function (t) { t.hidden = false; });
          firstVisible = 0;
        }
      }
      syncDots();
      // prefer the slide explicitly tagged for the chosen colour; else first visible
      // first load in no-hide mode: open on the hero photo; only jump to a colour's photo when the shopper picks one
      var target = (initial && galleryNoHide) ? firstVisible : (exactIdx > -1 ? exactIdx : firstVisible);
      if (target > -1) { if (track) track.scrollLeft = slides[target].offsetLeft - track.offsetLeft; activeIdx = -1; setActiveThumb(target); }
    }
    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { goTo(idx); }); });

    // ---------- inline image zoom (zooms the photo in place, no lightbox) ----------
    // Touch devices skip zoom entirely so a tap on the gallery never zooms (swipe-only on mobile).
    var jpdpCanHover = !(window.matchMedia) || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    (jpdpCanHover ? slides : []).forEach(function (sl) {
      var im = sl.querySelector('img');
      if (!im) return;
      var ZOOM = 2.5, zoomed = false, hires = false;
      im.style.cursor = 'zoom-in';
      sl.style.overflow = 'hidden';
      function origin(e) {
        var pt = (e.touches && e.touches[0]) ? e.touches[0] : e;
        var r = sl.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, (pt.clientX - r.left) / r.width * 100));
        var y = Math.max(0, Math.min(100, (pt.clientY - r.top) / r.height * 100));
        im.style.transformOrigin = x + '% ' + y + '%';
      }
      function zoomOut() { zoomed = false; im.style.transform = ''; im.style.cursor = 'zoom-in'; }
      im.addEventListener('click', function (e) {
        zoomed = !zoomed;
        if (zoomed) {
          var hi = im.getAttribute('data-zoom');
          if (hi && !hires) { im.src = hi; hires = true; }
          origin(e);
          im.style.transform = 'scale(' + ZOOM + ')';
          im.style.cursor = 'zoom-out';
        } else { zoomOut(); }
      });
      im.addEventListener('mousemove', function (e) { if (zoomed) origin(e); });
      im.addEventListener('mouseleave', function () { if (zoomed) zoomOut(); });
      im.addEventListener('touchmove', function (e) { if (zoomed) { e.preventDefault(); origin(e); } }, { passive: false });
    });

    // active dot + thumb follow the swipe position live (once per frame)
    function nearestSlide() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = -1, bestDist = Infinity;
      slides.forEach(function (s, idx) {
        if (s.hidden) return;
        var c = s.offsetLeft + s.clientWidth / 2 - track.offsetLeft;
        var d = Math.abs(c - center);
        if (d < bestDist) { bestDist = d; best = idx; }
      });
      return best;
    }
    if (track) {
      var scrollRaf = 0;
      track.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          var best = nearestSlide();
          if (best > -1) setActiveThumb(best);
        });
      }, { passive: true });

      // infinite loop: swipe past the last photo -> back to the first (and first -> last)
      var tx = 0, ty = 0, atStart = false, atEnd = false;
      track.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; tx = t.clientX; ty = t.clientY;
        var max = track.scrollWidth - track.clientWidth;
        atStart = track.scrollLeft <= 2;
        atEnd = track.scrollLeft >= max - 2;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (!atStart && !atEnd) return;
        var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        var vis = slides.filter(function (s) { return !s.hidden; });
        if (vis.length < 2) return;
        var target = null;
        if (atEnd && dx < 0) target = vis[0];
        else if (atStart && dx > 0) target = vis[vis.length - 1];
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActiveThumb(slides.indexOf(target));
      }, { passive: true });
    }


    // ---------- desktop: arrow buttons step through the gallery (loops end to end) ----------
    // The page wheel/trackpad scroll no longer moves the photos on desktop; the arrows,
    // thumbnails and dots do. Touch devices keep native swipe (jpdpCanHover is false there).
    if (track && jpdpCanHover && slides.length > 1) {
      root.classList.add('jpdp--arrows');
      var stage = document.createElement('div');
      stage.className = 'jpdp__stage';
      track.parentNode.insertBefore(stage, track);
      stage.appendChild(track);
      function step(dir) {
        var vis = slides.filter(function (s) { return !s.hidden; });
        if (vis.length < 2) return;
        var cur = vis.indexOf(slides[activeIdx]);
        if (cur < 0) cur = 0;
        var next = (cur + dir + vis.length) % vis.length;
        scrollToSlide(vis[next]);
        setActiveThumb(slides.indexOf(vis[next]));
      }
      [['prev', -1, 'Previous photo', 'M15 5l-7 7 7 7'], ['next', 1, 'Next photo', 'M9 5l7 7-7 7']].forEach(function (cfg) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jpdp__arrow jpdp__arrow--' + cfg[0];
        btn.setAttribute('aria-label', cfg[2]);
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="' + cfg[3] + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        btn.addEventListener('click', function () { step(cfg[1]); });
        stage.appendChild(btn);
      });
      // left/right arrow keys work while the pointer is over the photo
      var overStage = false;
      stage.addEventListener('mouseenter', function () { overStage = true; });
      stage.addEventListener('mouseleave', function () { overStage = false; });
      document.addEventListener('keydown', function (e) {
        if (!overStage || e.altKey || e.metaKey || e.ctrlKey) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      });
    }

    /* ---------- swatches / sizes ---------- */
    var swatches = $$('[data-swatch]');
    var sizeBtns = $$('[data-size]');
    var colorVal = $('[data-color-val]');
    var sizeVal = $('[data-size-val]');

    // ---- K59 waist + length mode ----
    var waistBtns = $$('[data-waist]');
    var lengthBtns = $$('[data-length]');
    var lengthOpt = (lengthBtns[0] && lengthBtns[0].closest) ? lengthBtns[0].closest('.jpdp__opt') : null;
    function nudgeLength() {
      if (!lengthOpt || state.length != null) return;   // only prompt when length not chosen yet
      lengthOpt.classList.remove('is-nudge');
      void lengthOpt.offsetWidth;                        // reflow to restart the animation
      lengthOpt.classList.add('is-nudge');
    }
    var waistMode = !!(waistBtns.length && lengthBtns.length);
    var waistValEl = $('[data-waist-val]');
    var lengthValEl = $('[data-length-val]');
    function parseSize(val) {
      val = val || '';
      var isLong = val.toLowerCase().indexOf('long') > -1;
      var waist = isLong ? val.replace(/[\s-]*long\s*$/i, '').replace(/[\s-]+$/, '') : val;
      return { waist: waist, length: isLong ? 'Long' : 'Regular' };
    }
    function comboSizeValue() {
      if (state.waist == null || state.length == null) return null;
      var m = variants.filter(function (v) {
        if (colorPos > -1 && v.options[colorPos] !== state.color) return false;
        var ps = parseSize(v.options[sizePos]);
        return ps.waist === state.waist && ps.length === state.length;
      })[0];
      return m ? m.options[sizePos] : null;
    }
    function waistOk(w) {
      return variants.some(function (v) {
        if (colorPos > -1 && v.options[colorPos] !== state.color) return false;
        if (!v.available) return false;
        var ps = parseSize(v.options[sizePos]);
        if (ps.waist !== w) return false;
        if (state.length != null && ps.length !== state.length) return false;
        return true;
      });
    }
    function lengthOk(l) {
      return variants.some(function (v) {
        if (colorPos > -1 && v.options[colorPos] !== state.color) return false;
        if (!v.available) return false;
        var ps = parseSize(v.options[sizePos]);
        if (ps.length !== l) return false;
        if (state.waist != null && ps.waist !== state.waist) return false;
        return true;
      });
    }

    /* Does the CURRENT colour sell this waist at all (ignoring the chosen length)? */
    function waistExistsForColor(w) {
      return variants.some(function (v) {
        if (colorPos > -1 && v.options[colorPos] !== state.color) return false;
        if (!v.available) return false;
        return parseSize(v.options[sizePos]).waist === w;
      });
    }
    /* Does the CURRENT colour sell this length at all (ignoring the chosen waist)? */
    function lengthExistsForColor(l) {
      return variants.some(function (v) {
        if (colorPos > -1 && v.options[colorPos] !== state.color) return false;
        if (!v.available) return false;
        return parseSize(v.options[sizePos]).length === l;
      });
    }
    /* Is the exact waist+length combo buyable in the current colour? */
    function comboAvailable() {
      return variants.some(function (v) {
        if (colorPos > -1 && v.options[colorPos] !== state.color) return false;
        if (!v.available) return false;
        var ps = parseSize(v.options[sizePos]);
        return ps.waist === state.waist && ps.length === state.length;
      });
    }
    /* Drop any waist/length the newly chosen colour cannot sell.
       Without this a button stays pressed AND disabled (a dead bubble) and, because waistOk()
       filters by state.length and lengthOk() filters by state.waist, the two can deadlock and
       grey each other out. Clearing re-prompts the shopper instead. */
    function pruneSelection() {
      if (state.waist != null && !waistExistsForColor(state.waist)) state.waist = null;
      if (state.length != null && !lengthExistsForColor(state.length)) { state.length = null; prunedLength = true; }
      /* both exist separately but not together: keep the waist (the fit decision), re-ask length */
      if (state.waist != null && state.length != null && !comboAvailable()) { state.length = null; prunedLength = true; }
    }

    swatches.forEach(function (b) {
      b.addEventListener('click', function () {
        state.color = b.getAttribute('data-color');
        prunedLength = false;
        render();
        filterGallery();
        /* only prompt when THIS colour switch removed a length the shopper had already picked.
           Never nudge someone who simply hasn't chosen one yet. */
        if (prunedLength) nudgeLength();
      });
    });
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        state.size = b.getAttribute('data-value');
        render();
      });
    });
    waistBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        state.waist = b.getAttribute('data-waist');
        render();
        nudgeLength();
      });
    });
    lengthBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        state.length = b.getAttribute('data-length');
        if (lengthOpt) lengthOpt.classList.remove('is-nudge');
        render();
      });
    });

    /* ---------- price / stock / ATC ---------- */
    var priceEl = $('[data-price]');
    var wasEl = $('[data-was]');
    var stockEl = $('[data-stock]');
    var preEl = $('[data-preorder]');
    var preTextEl = $('[data-preorder-text]');
    var shipTagEl = $('[data-shiptag]');
    var shipTextEl = $('[data-shiptag-text]');
    var atcEls = $$('[data-atc], [data-atc-sticky]');
    var labelEls = $$('[data-atc-label]');
    var atcPriceEls = $$('[data-atc-price]');
    var payForm = $('.jpdp__payForm');
    var payId = $('[data-pay-id]');

    function render() {
      // swatch pressed
      swatches.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-color') === state.color ? 'true' : 'false');
      });
      if (colorVal && colorPos > -1) colorVal.textContent = state.color || '';

      // K59: recombine waist + length into the real size value, set availability
      if (waistMode) {
        pruneSelection();
        state.size = comboSizeValue();
        waistBtns.forEach(function (b) {
          var w = b.getAttribute('data-waist');
          b.disabled = !waistOk(w);
          b.classList.toggle('is-pre', !b.disabled && preForPart('waist', w));
          b.setAttribute('aria-pressed', state.waist === w ? 'true' : 'false');
        });
        lengthBtns.forEach(function (b) {
          var l = b.getAttribute('data-length');
          b.disabled = !lengthOk(l);
          b.classList.toggle('is-pre', !b.disabled && preForPart('length', l));
          b.setAttribute('aria-pressed', state.length === l ? 'true' : 'false');
        });
        if (waistValEl) waistValEl.textContent = state.waist ? (': ' + state.waist) : '';
        if (lengthValEl) lengthValEl.textContent = state.length ? (': ' + jT(state.length.toLowerCase(), state.length)) : '';
      }

      // size availability + pressed
      sizeBtns.forEach(function (b) {
        var sv = b.getAttribute('data-value');
        var ok = sizeAvailableForColor(sv);
        b.disabled = !ok;
        b.classList.toggle('is-pre', ok && preForSize(sv));
        b.setAttribute('aria-pressed', (state.size === sv) ? 'true' : 'false');
      });
      // if current size no longer valid for colour, clear it
      if (!waistMode && state.size != null && !sizeAvailableForColor(state.size)) state.size = null;
      if (sizeVal) sizeVal.textContent = state.size != null ? (': ' + state.size) : '';

      var v = findVariant();
      var needSize = (sizePos > -1 && state.size == null);

      // price
      if (v && priceEl) priceEl.textContent = money(v.price);
      if (wasEl) {
        if (v && v.compare > v.price) { wasEl.style.display = ''; wasEl.textContent = money(v.compare); }
        else wasEl.style.display = 'none';
      }

      // stock messaging
      if (stockEl) {
        stockEl.className = 'jpdp__stock';
        stockEl.textContent = '';
        if (!needSize && v) {
          if (!v.available) { stockEl.classList.add('jpdp__stock--out'); stockEl.textContent = jT('sold_out_size','Sold out in this size'); }
          else if (isPre(v)) { /* the pre-order notice below carries the message */ }
          else if (v.managed && v.qty > 0 && v.qty <= lowStock) { stockEl.classList.add('jpdp__stock--low'); stockEl.textContent = jT('low_stock','Low stock, only [n] left', v.qty); }
        }
      }

      // ATC state + label
      var canAdd = v && v.available && !needSize;
      var soldOut = !needSize && v && !v.available;
      var preSel = !needSize && !!v && v.available && isPre(v);

      // inline pre-order notice under the sizes
      if (preEl) {
        preEl.hidden = !preSel;
        if (preTextEl && preSel) preTextEl.textContent = 'Pre-order. ' + preNote;
      }
      // reuse the clock badge to carry the date while a pre-order size is selected
      if (shipTagEl && shipTextEl) {
        shipTagEl.classList.toggle('is-pre', preSel);
        var st = preSel ? preNote : (shipTagEl.getAttribute('data-default') || shipTextEl.textContent);
        if (shipTextEl.textContent !== st) shipTextEl.textContent = st;
        shipTagEl.setAttribute('aria-label', st);
      }

      syncTiers(v);

      var label = needSize ? jT('select_size','Select a size') : (soldOut ? jT('sold_out','Sold out') : (preSel ? jT('pre_order','Pre-order') : jT('add_to_cart','Add to cart')));
      var total = canAdd ? v.price : 0;
      if (canAdd && bundle.on && bundle.variant) { total += bundle.discountedPrice(); label = jT('add_both','Add both to cart'); }
      else if (canAdd && tier.qty > 1) {
        label = jT('add_n','Add [n] to cart', tier.qty);
        total = (tier.cents != null) ? tier.cents : v.price * tier.qty;
      }

      atcEls.forEach(function (b) {
        // only truly disable when sold out; "select a size" stays clickable (scrolls to sizes)
        b.disabled = soldOut;
        b.classList.toggle('is-muted', !canAdd);
        b.classList.remove('is-loading');
      });
      labelEls.forEach(function (el) { el.textContent = label; });
      atcPriceEls.forEach(function (el) { el.textContent = canAdd ? money(total) : ''; });

      // Shop Pay / dynamic checkout: keep its variant in sync, show only when a
      // complete, in-stock variant is selected (it checks out that single variant)
      if (payId && v && payId.value != v.id) {
        payId.value = v.id;
        payId.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (payForm) payForm.style.display = canAdd ? '' : 'none';
    }

    /* ---------- bundle (cross-sell) ----------
       Can offer several styles. The belt discount is scoped to a whole collection, so
       the page offers the whole collection and the swatch/size rows are rebuilt when
       the style changes. */
    var bundleEl = $('[data-bundle]');
    var bundle = {
      on: false, style: null, color: null, size: null, variant: null, pct: 0,
      colorPos: -1, sizePos: -1, variants: [], data: null,
      discountedPrice: function () {
        if (!this.variant) return 0;
        var p = this.variant.price || 0;
        return Math.round(p * (1 - this.pct / 100));
      }
    };

    /* tier ladder state (used by render via syncTiers; must exist before the bundle init) */
    var rungEls = $$('[data-rung]');
    var tier = { qty: 1, cents: null };
    /* Server-rendered, so this is reliable regardless of script order. */
    var packMode = !!document.getElementById('jbp');

    if (bundleEl) {
      var bAll = null;
      try { bAll = JSON.parse($('[data-bundle-data]', bundleEl).textContent); } catch (e) {}
      if (bAll && bAll.order && bAll.order.length) {
        bundle.pct = parseInt(bundleEl.getAttribute('data-b-pct') || '0', 10) || 0;

        var toggle = $('[data-bundle-toggle]', bundleEl);
        var bImg = $('.jpdp__bundleImg img', bundleEl);
        var bColorVal = $('[data-b-color-val]', bundleEl);
        var bStyleVal = $('[data-b-style-val]', bundleEl);
        var bColorsWrap = $('[data-b-color-wrap]', bundleEl);
        var bSizesWrap = $('[data-b-size-wrap]', bundleEl);
        var bColorsRow = $('[data-b-colors]', bundleEl);
        var bSizesRow = $('[data-b-sizes]', bundleEl);
        var bColorName = $('[data-b-color-name]', bundleEl);
        var bSizeName = $('[data-b-size-name]', bundleEl);
        var bStyleBtns = $$('[data-b-style]', bundleEl);

        function bVariant() {
          return bundle.variants.filter(function (v) {
            if (bundle.colorPos > -1 && v.options[bundle.colorPos] !== bundle.color) return false;
            if (bundle.sizePos > -1 && bundle.size != null && v.options[bundle.sizePos] !== bundle.size) return false;
            return true;
          })[0];
        }
        function bSizeOk(sz) {
          return bundle.variants.some(function (v) {
            return (bundle.colorPos < 0 || v.options[bundle.colorPos] === bundle.color) &&
                   (bundle.sizePos < 0 || v.options[bundle.sizePos] === sz) && v.available;
          });
        }
        function bColorOk(c) {
          return bundle.variants.some(function (v) {
            return (bundle.colorPos < 0 || v.options[bundle.colorPos] === c) && v.available;
          });
        }
        function bColorImage(color) {
          var v = bundle.variants.filter(function (x) { return bundle.colorPos < 0 || x.options[bundle.colorPos] === color; })[0];
          return (v && v.img) || (bundle.data && bundle.data.img);
        }

        /* Swap the whole option set when the style changes. */
        function setStyle(handle, keepSelection) {
          var d = bAll.products[handle];
          if (!d) return;
          bundle.style = handle;
          bundle.data = d;
          bundle.variants = d.variants || [];
          bundle.colorPos = typeof d.colorPos === 'number' ? d.colorPos : -1;
          bundle.sizePos = typeof d.sizePos === 'number' ? d.sizePos : -1;

          if (bColorName && d.colorName) bColorName.textContent = d.colorName;
          if (bSizeName && d.sizeName) bSizeName.textContent = d.sizeName;

          var colors = d.colors || [];
          if (bColorsRow) {
            bColorsRow.innerHTML = colors.map(function (c) {
              return '<button type="button" class="jpdp__bswatch" data-b-color data-value="' +
                String(c.v).replace(/"/g, '&quot;') + '" aria-pressed="false" title="' +
                String(c.v).replace(/"/g, '&quot;') + '" aria-label="' + String(c.v).replace(/"/g, '&quot;') + '">' +
                (c.img ? '<img src="' + c.img + '" alt="" width="44" height="44" loading="lazy">' : '') + '</button>';
            }).join('');
          }
          if (bColorsWrap) bColorsWrap.hidden = colors.length < 2;

          var sizes = d.sizes || [];
          if (bSizesRow) {
            bSizesRow.innerHTML = sizes.map(function (sv) {
              return '<button type="button" class="jpdp__mini" data-b-size data-value="' +
                String(sv).replace(/"/g, '&quot;') + '" aria-pressed="false">' + sv + '</button>';
            }).join('');
          }
          if (bSizesWrap) bSizesWrap.hidden = !sizes.length;

          /* Carrying a colour name across styles is meaningless (Shadow vs Desert Camo),
             so a style switch resets to the first colour that is actually in stock. */
          if (!keepSelection || !bColorOk(bundle.color)) {
            var fv = bundle.variants.filter(function (v) { return v.available; })[0] || bundle.variants[0];
            bundle.color = (fv && bundle.colorPos > -1) ? fv.options[bundle.colorPos] : null;
          }
          bundle.size = null;

          bStyleBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-value') === handle ? 'true' : 'false'); });
          if (bStyleVal) bStyleVal.textContent = d.title || '';
          bRender();
        }

        function bRender() {
          $$('[data-b-color]', bundleEl).forEach(function (b) {
            var c = b.getAttribute('data-value');
            b.classList.toggle('jpdp__bswatch--soldout', !bColorOk(c));
            b.setAttribute('aria-pressed', c === bundle.color ? 'true' : 'false');
          });
          var sizeBtns = $$('[data-b-size]', bundleEl);
          sizeBtns.forEach(function (b) {
            var sz = b.getAttribute('data-value');
            b.disabled = !bSizeOk(sz);
            b.setAttribute('aria-pressed', bundle.size === sz ? 'true' : 'false');
          });
          if (bundle.size != null && !bSizeOk(bundle.size)) bundle.size = null;
          /* Toggled ON with no size picked: auto-pick the first available one so the
             total moves immediately. The customer can still change it. */
          if (bundle.on && bundle.sizePos > -1 && bundle.size == null) {
            var fv = bundle.variants.filter(function (v) {
              return (bundle.colorPos < 0 || v.options[bundle.colorPos] === bundle.color) && v.available;
            })[0];
            if (fv) bundle.size = fv.options[bundle.sizePos];
            sizeBtns.forEach(function (b) { b.setAttribute('aria-pressed', bundle.size === b.getAttribute('data-value') ? 'true' : 'false'); });
          }
          bundle.variant = (bundle.sizePos > -1 && bundle.size == null) ? null : bVariant();
          var ci = bColorImage(bundle.color);
          if (bImg && ci) bImg.src = ci;
          if (bColorVal) bColorVal.textContent = bundle.color || '';
          render();
        }

        /* Delegated: the colour and size rows are rebuilt on every style change. */
        bundleEl.addEventListener('click', function (e) {
          var c = e.target.closest ? e.target.closest('[data-b-color]') : null;
          if (c && bundleEl.contains(c)) { bundle.color = c.getAttribute('data-value'); bundle.size = null; bRender(); return; }
          var z = e.target.closest ? e.target.closest('[data-b-size]') : null;
          if (z && bundleEl.contains(z)) { if (z.disabled) return; bundle.size = z.getAttribute('data-value'); bRender(); return; }
          var st = e.target.closest ? e.target.closest('[data-b-style]') : null;
          if (st && bundleEl.contains(st)) { setStyle(st.getAttribute('data-value'), false); return; }
        });

        function setOn(on) {
          bundle.on = on;
          bundleEl.classList.toggle('is-on', on);
          if (toggle) toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
          bRender();
        }
        if (toggle) {
          toggle.addEventListener('click', function (e) {
            if (e.target.closest && e.target.closest('[data-b-style],[data-b-color],[data-b-size]')) return;
            setOn(!bundle.on);
          });
          toggle.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOn(!bundle.on); } });
        }
        setStyle(bAll.order[0], false);
      }
    }

    /* ---------- multi-buy tier ladder ----------
       The tier prices come from Shopify automatic ORDER discounts, so the cart is
       where they formally land. Showing the tier total on the button anyway means the
       number in the ad is the number the customer sees before they commit. */
    /* rungEls / tier / packMode are declared up top, before the bundle block:
       the bundle init calls render() -> syncTiers(), and when these were declared
       down here they were still undefined, the init threw, and the Add to cart
       listener never got attached on any page with a cross-sell bundle. */

    /* How many of THIS variant can actually ship. A rung that promises three while the
       chosen colour has two left is the worst version of this feature: the button says
       "Add 3 to cart $75" and the cart quietly comes back with two at $55. */
    function stockOf(v) {
      if (!v) return 0;
      if (!v.managed || v.policy === 'continue') return Infinity;
      return typeof v.qty === 'number' ? v.qty : 0;
    }
    function selectRung(el) {
      rungEls.forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-checked', 'false'); });
      el.classList.add('is-on'); el.setAttribute('aria-checked', 'true');
      tier.qty = parseInt(el.getAttribute('data-tier-qty'), 10) || 1;
      var c = parseInt(el.getAttribute('data-tier-cents'), 10);
      tier.cents = isNaN(c) ? null : c;
    }
    function syncTiers(v) {
      if (!rungEls.length) return;
      /* In pack mode a multi rung opens the mix-and-match picker, so the stock of the
         colour currently on screen says nothing about whether a 3-pack is possible:
         it gets built from three different colorways. Only the quantity-add fallback
         (no builder on the page) needs the clamp. */
      if (packMode) {
        rungEls.forEach(function (b) {
          b.classList.remove('is-unavail');
          b.disabled = false;
          var h = b.querySelector('[data-rung-hint]');
          if (h) { h.textContent = ''; h.hidden = true; }
        });
        return;
      }
      var stock = stockOf(v);
      var fallback = null;
      rungEls.forEach(function (b) {
        var q = parseInt(b.getAttribute('data-tier-qty'), 10) || 1;
        var ok = q <= stock;
        b.classList.toggle('is-unavail', !ok);
        b.disabled = !ok;
        var hint = b.querySelector('[data-rung-hint]');
        if (hint) {
          /* Live from inventory, never a fixed number. */
          hint.textContent = ok ? '' : (stock > 0 ? jT('only_left_color','Only [n] left in this color', stock) : jT('sold_out_color','Sold out in this color'));
          hint.hidden = ok;
        }
        if (ok) fallback = b;
      });
      /* If the colour the shopper just picked cannot cover the selected rung, step down
         to the biggest one it can, rather than letting the button lie. */
      var current = rungEls.filter(function (b) { return b.classList.contains('is-on'); })[0];
      if ((!current || current.disabled) && fallback) selectRung(fallback);
    }

    if (rungEls.length) {
      var first = rungEls[0];
      tier.qty = parseInt(first.getAttribute('data-tier-qty'), 10) || 1;
      tier.cents = parseInt(first.getAttribute('data-tier-cents'), 10);
      if (isNaN(tier.cents)) tier.cents = null;
      rungEls.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          var q = parseInt(b.getAttribute('data-tier-qty'), 10) || 1;
          /* A multi rung opens the mix-and-match picker rather than adding N of the
             variant on screen. Three of one colorway is not the offer, and the tier is
             a collection-level quantity discount, so any mix qualifies. Slot 1 is
             seeded with what they were already looking at. */
          if (q > 1 && packMode) {
            if (!window.JabBeltPack) return;
            var v = findVariant();
            window.JabBeltPack.open(q, {
              style: root.getAttribute('data-product-handle'),
              color: colorPos > -1 && v ? v.options[colorPos] : (state.color || null),
              size: sizePos > -1 && v ? v.options[sizePos] : (state.size || null)
            });
            return;
          }
          selectRung(b);
          render();
        });
      });
    }

    /* ---------- pack cards (packs mode): open the mix-and-match builder, slot 1 seeded with what's on screen ---------- */
    $$('[data-pack-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!window.JabBeltPack) return;
        var q = parseInt(b.getAttribute('data-pack-qty'), 10) || 2;
        var v = findVariant();
        window.JabBeltPack.open(q, {
          style: root.getAttribute('data-product-handle'),
          color: colorPos > -1 && v ? v.options[colorPos] : (state.color || null),
          size: sizePos > -1 && v ? v.options[sizePos] : (state.size || null)
        });
      });
    });

    /* ---------- add to cart ---------- */
    function flashSizes() {
      var wrap = $('[data-sizes]');
      if (!wrap) return;
      wrap.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-5px)' }, { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }], { duration: 240 });
    }
    function add() {
      var v = findVariant();
      if (sizePos > -1 && state.size == null) { flashSizes(); var sb = $('[data-sizes]'); if (sb) sb.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (!v || !v.available) return;

      // Visible property (no leading underscore) so it shows in cart, checkout and the order email.
      var qty = (!bundle.on && tier.qty > 1) ? tier.qty : 1;
      var cap = stockOf(v);
      if (cap !== Infinity && qty > cap) qty = Math.max(1, cap);
      var items = isPre(v)
        ? [{ id: v.id, quantity: qty, properties: { 'Pre-order': preNote } }]
        : [{ id: v.id, quantity: qty }];
      if (bundle.on && bundle.variant && bundle.variant.available) {
        items.push({ id: bundle.variant.id, quantity: 1, properties: { _bundle: 'denim-belt' } });
      } else if (bundle.on && bundle.sizePos > -1 && bundle.size == null) {
        // belt selected for bundle but no size chosen — nudge, still add denim
        var bb = $('[data-b-sizes]', bundleEl);
        if (bb) bb.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-5px)' }, { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }], { duration: 240 });
      }

      atcEls.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
      window.fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () { atcEls.forEach(function (b) { b.classList.remove('is-loading'); }); render(); })
        .catch(function () { atcEls.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; }); });
    }
    atcEls.forEach(function (b) { b.addEventListener('click', add); });

    /* ---------- sticky mobile bar ---------- */
    var sticky = $('[data-sticky]') || document.querySelector('[data-sticky]');
    var mainAtc = $('[data-atc]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var atcPassed = false, footerNear = false;
      function updateSticky(){ sticky.classList.toggle('is-visible', atcPassed && !footerNear); }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          // show ONLY once the main button has scrolled ABOVE the viewport
          var scrolledPast = en.boundingClientRect.bottom < 0;
          atcPassed = !en.isIntersecting && scrolledPast;
          updateSticky();
        });
      }, { threshold: 0 });
      io.observe(mainAtc);

      // phase the sticky bar OUT a bit before the footer reaches it (no overlap)
      var footer = document.querySelector('footer') || document.querySelector('.jab-footer');
      if (footer) {
        var fio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { footerNear = en.isIntersecting; updateSticky(); });
        }, { root: null, rootMargin: '0px 0px 140px 0px', threshold: 0 });
        fio.observe(footer);
      }
    }

    /* ---------- size guide modal ---------- */
    var guide = $('[data-guide]');
    if (guide) {
      // portal to <body> so position:fixed resolves against the viewport, not a
      // transformed/contained theme ancestor (which made it fill the page near the
      // bottom of scroll with an unreachable close + no way to tap off)
      if (guide.parentNode !== document.body) document.body.appendChild(guide);
      /* document-wide so buttons in other sections (e.g. jab-pdp-fit) open it too */
      $$('[data-open-guide]', document).forEach(function (b) { b.addEventListener('click', function () { guide.classList.add('is-open'); guide.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }); });
      $$('[data-guide-close]', guide).forEach(function (b) { b.addEventListener('click', function () { guide.classList.remove('is-open'); guide.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { guide.classList.remove('is-open'); document.documentElement.style.overflow = ''; } });
    }

    /* ---------- description read-more ---------- */
    var desc = $('[data-desc]');
    if (desc) {
      var body = $('.jpdp__descBody', desc);
      var more = $('[data-desc-more]', desc);
      if (body && more) {
        if (body.scrollHeight <= body.clientHeight + 4) { desc.setAttribute('data-clamped', 'false'); more.style.display = 'none'; }
        more.addEventListener('click', function () {
          var clamped = desc.getAttribute('data-clamped') === 'true';
          desc.setAttribute('data-clamped', clamped ? 'false' : 'true');
          more.textContent = clamped ? jT('read_less','Read less') : jT('read_more','Read more');
        });
      }
    }

    /* ---------- boot ---------- */
    render();
    filterGallery(!/[?&]variant=/.test(window.location.search));   // arriving from a colourway card (?variant=) still jumps to that colour
  }

  /* ---------- feature details: care accordion (jab-pdp-features) ---------- */
  function initFeatures(root) {
    if (root.__jpdpf) return;
    root.__jpdpf = 1;
    var toggle = root.querySelector('[data-care-toggle]');
    var panel = root.querySelector('[data-care-panel]');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) panel.setAttribute('hidden', ''); else panel.removeAttribute('hidden');
      });
    }
  }

  /* ---------- autoplay videos: pause when off-screen (saves data/CPU) ---------- */
  function initVideos() {
    if (!('IntersectionObserver' in window)) return;
    Array.prototype.slice.call(document.querySelectorAll('[data-video]')).forEach(function (v) {
      if (v.__jvid) return;
      v.__jvid = 1;
      var media = v.closest ? v.closest('.jpdpf__media') : null;
      function vloaded() { if (media) media.classList.add('is-vloaded'); }
      v.addEventListener('loadeddata', vloaded);
      v.addEventListener('playing', vloaded);
      if (v.readyState >= 2) vloaded();
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.25 }).observe(v);
    });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-jpdp]')).forEach(initRoot);
    Array.prototype.slice.call(document.querySelectorAll('[data-jpdpf]')).forEach(initFeatures);
    initVideos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
